/**
 * PerfilClinicoForm — Formulario de condiciones crónicas del paciente.
 *
 * Requirements: M4.3.2
 */

import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { PerfilClinicoBaseData } from "@/hooks/use-muestras";

interface PerfilClinicoFormProps {
  value: PerfilClinicoBaseData;
  onChange: (value: PerfilClinicoBaseData) => void;
  disabled?: boolean;
}

const CONDICIONES: Array<{ key: keyof PerfilClinicoBaseData; labelKey: string }> = [
  { key: "es_diabetico", labelKey: "muestras.encuesta.es_diabetico" },
  { key: "es_hipertenso", labelKey: "muestras.encuesta.es_hipertenso" },
  { key: "enfermedad_renal", labelKey: "muestras.encuesta.enfermedad_renal" },
  { key: "enfermedad_tiroidea", labelKey: "muestras.encuesta.enfermedad_tiroidea" },
  { key: "usa_anticoagulantes", labelKey: "muestras.encuesta.usa_anticoagulantes" },
  { key: "tiene_anemia", labelKey: "muestras.encuesta.tiene_anemia" },
  { key: "plaquetas_bajas", labelKey: "muestras.encuesta.plaquetas_bajas" },
];

export function PerfilClinicoForm({ value, onChange, disabled }: PerfilClinicoFormProps) {
  const { t } = useTranslation();

  const handleChange = (key: keyof PerfilClinicoBaseData, checked: boolean) => {
    onChange({ ...value, [key]: checked });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {CONDICIONES.map(({ key, labelKey }) => (
        <div key={key} className="flex items-center gap-2">
          <Checkbox
            id={key}
            checked={value[key] ?? false}
            onCheckedChange={(checked) => handleChange(key, checked === true)}
            disabled={disabled}
          />
          <Label htmlFor={key} className={`cursor-pointer ${disabled ? "opacity-50" : ""}`}>
            {t(labelKey)}
          </Label>
        </div>
      ))}
    </div>
  );
}
